import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postAttendanceViolation = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `/monitoring-operator/violations/attendance`,
    data: payload,
  });

  return data?.data;
};

export default postAttendanceViolation;
